<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        @sort="onSort"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="management_date" slot-scope="data">{{
            (!!data.item.management_date.date
                ? data.item.management_date.date
                : data.item.management_date) | date
        }}</template>
        <template slot="created_at" slot-scope="data">{{
            data.item.created_at | date
        }}</template>
        <template slot="description" slot-scope="data">
            <div v-html="data.item.description"></div>
        </template>
        <template slot="photos" slot-scope="data">
            <b-button
                size="sm"
                v-if="!data.detailsShowing"
                :disabled="!data.item.internal_management_photos.length"
                @click="openModalInternalManagementFiles(data.item)"
                variant="primary"
            >
                <i class="fa fa-files-o" aria-hidden="true"></i>
                <b-badge>{{
                    data.item.internal_management_photos.length
                }}</b-badge>
            </b-button>
        </template>
        <template slot="actions" slot-scope="data">
            <div class="d-flex">
                <div class="px-1">
                    <b-button
                        variant="primary"
                        @click="onStartEditing(data.item)"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                </div>
                <div class="px-1">
                    <b-button
                        variant="danger"
                        @click="onStartDeleting(data.item)"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </div>
            </div>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields'
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        onStartEditing: {
            type: Function,
            required: true,
        },
        onStartDeleting: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            fields: fields,
        }
    },
    methods: {
        onChangePage(page) {
            this.$emit('change-page', page)
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        openModalInternalManagementFiles(item) {
            this.$emit('open-internal-management-files', item)
        },
    },
}
</script>
